/**
 * The 88px circled tick on the standard reset-password-success screen.
 *
 * Copied from Auth0's own stylesheet, not redrawn: this is the exact mask SVG
 * behind `.success-lock` in
 * cdn.auth0.com/ulp/react-components/1.223.1/css/main_wcag_compliant.cdn.min.css.
 * Universal Login paints the icon as the theme's success colour shown through
 * the SVG as a mask, so the stroke colour inside the SVG doesn't matter; the
 * theme colour does. Same technique here, so a theme colour change recolours
 * both renderings identically.
 *
 * Success only. reset-password-error went back to standard rendering (see
 * auth0_prompt_screen_renderer.reset_password in infra/terraform/auth0.tf), so
 * the `.error-cross` variant that used to live here was removed with it.
 */
const SUCCESS_MASK =
  "url(\"data:image/svg+xml;charset=utf-8,<svg width='84' height='84' xmlns='http://www.w3.org/2000/svg'><g stroke='%231BC462' stroke-width='3' fill='none' fill-rule='evenodd'><circle cx='42' cy='42' r='40.5'/><path d='M27 48.429L39.857 57 57 27'/></g></svg>\")";

export default function SuccessIcon() {
  return (
    <span
      aria-hidden="true"
      data-testid="status-icon-success"
      // mb 26px, not the stylesheet's 24: the hosted icon is inline-block, so
      // it also picks up a ~2px baseline gap. Measured icon bottom -> title
      // top = 26px on the live page.
      className="block self-center w-[88px] h-[88px] mb-[26px]"
      style={{
        backgroundColor: "var(--ul-theme-color-success, #00a651)",
        maskImage: SUCCESS_MASK,
        WebkitMaskImage: SUCCESS_MASK,
        maskRepeat: "no-repeat",
        WebkitMaskRepeat: "no-repeat",
        maskPosition: "center",
        WebkitMaskPosition: "center",
      }}
    />
  );
}
